export default __webpack_public_path__ + "static/copywriting-secrets-02dd710cdce84ac3181142373fabb840.jpg";